import { CoordinationCardVersion as ServerCoordinationCardVersion } from 'server/models/CoordinationCardVersion';
import { CoordinationCard, SupportsCCardDisplayOrder } from './CoordinationCard';

export * from 'server/models/CoordinationCardVersion';

export class CoordinationCardVersion extends ServerCoordinationCardVersion implements SupportsCCardDisplayOrder {
    EffectiveStatusLabel(bypassAltPendingLabel? : boolean) {
        return CoordinationCard.EffectiveStatusLabelImpl(this, bypassAltPendingLabel);
    }
}



// WEBPACK FOOTER //
// ./data/models/CoordinationCardVersion.ts